import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'
import { SVGIconProps } from 'commonTypes'

const DetailedAnalysisIcon = ({ fill, ...props }: SVGIconProps) => {
    return (
        <SvgIcon viewBox="0 0 511.999 511.999" {...props}>
            <g>
                <g>
                    <path
                        fill={fill ?? '#09293E'}
                        d="M331.217,108.319c-61.467-61.466-161.481-61.466-222.949,0c-29.776,29.775-46.175,69.365-46.175,111.475
			s16.399,81.7,46.174,111.475c30.733,30.733,71.104,46.101,111.474,46.101c40.371,0,80.741-15.367,111.475-46.101
			C392.683,269.801,392.683,169.787,331.217,108.319z M319.76,319.812c-55.149,55.153-144.887,55.15-200.036,0
			c-26.717-26.714-41.43-62.236-41.43-100.018s14.714-73.303,41.429-100.019C147.298,92.2,183.52,78.413,219.742,78.413
			c36.222,0,72.443,13.788,100.019,41.363C374.911,174.926,374.911,264.662,319.76,319.812z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        fill={fill ?? '#09293E'}
                        d="M392.752,147.546c-1.725-4.128-6.465-6.078-10.597-4.353c-4.128,1.725-6.076,6.469-4.353,10.598
			c8.712,20.86,13.129,43.068,13.129,66.003c0,4.475,3.626,8.101,8.1,8.101s8.101-3.626,8.101-8.101
			C407.133,194.704,402.295,170.396,392.752,147.546z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        fill={fill ?? '#09293E'}
                        d="M372.665,111.411c-6.076-8.536-12.946-16.653-20.417-24.124c-35.395-35.393-82.452-54.885-132.507-54.885
			c-4.474,0-8.101,3.626-8.101,8.1s3.627,8.101,8.101,8.101c45.727,0,88.717,17.807,121.05,50.141
			c6.837,6.836,13.12,14.259,18.674,22.064c1.581,2.221,4.074,3.403,6.607,3.403c1.624,0,3.265-0.488,4.691-1.502
			C374.407,120.114,375.258,115.056,372.665,111.411z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        fill={fill ?? '#09293E'}
                        d="M509.576,461.512l-61.097-61.097c-3.165-3.162-8.293-3.162-11.457,0l-12.601,12.601l-43.647-43.647
			c37.947-40.782,58.762-93.576,58.762-149.575c0-58.708-22.863-113.904-64.376-155.418C333.646,22.863,278.451,0,219.742,0
			C161.032,0,105.838,22.863,64.324,64.376c-85.697,85.698-85.697,225.138,0,310.836c41.513,41.512,96.708,64.375,155.418,64.375
			c56,0,108.792-20.815,149.574-58.762l43.647,43.647l-12.601,12.601c-3.163,3.165-3.163,8.293,0,11.456l61.097,61.097
			c1.582,1.581,3.656,2.372,5.729,2.372c2.073,0,4.146-0.791,5.729-2.372l36.659-36.659
			C512.738,469.805,512.738,464.676,509.576,461.512z M363.703,363.755c-38.453,38.455-89.58,59.632-143.961,59.632
			c-54.381,0-105.509-21.177-143.962-59.632c-79.381-79.381-79.381-208.542,0-287.922c38.454-38.455,89.581-59.632,143.962-59.632
			c54.381,0,105.508,21.177,143.961,59.632c38.455,38.454,59.632,89.581,59.632,143.961S402.158,325.302,363.703,363.755z
			 M467.189,492.444l-49.642-49.642l12.591-12.591c0.003-0.003,0.008-0.006,0.011-0.01c0.003-0.003,0.006-0.008,0.01-0.011
			l12.591-12.591l49.642,49.642L467.189,492.444z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        fill={fill ?? '#09293E'}
                        d="M331.036,263.537h-9.181V137.709c0-4.475-3.626-8.101-8.1-8.101h-38.883c-4.475,0-8.101,3.626-8.101,8.101v125.828
			h-22.681v-86.946c0-4.475-3.627-8.1-8.101-8.1h-38.882c-4.474,0-8.101,3.626-8.101,8.1v86.946h-22.681V163.63
			c0-4.475-3.627-8.101-8.101-8.101h-38.882c-4.474,0-8.101,3.626-8.101,8.101v99.906h-9.181c-4.474,0-8.101,3.626-8.101,8.1
			s3.627,8.101,8.101,8.101h17.281h38.882h38.883h38.882h38.882h38.883h17.281c4.475,0,8.101-3.626,8.101-8.101
			S335.511,263.537,331.036,263.537z M150.125,263.537h-22.681v-91.806h22.681V263.537z M227.89,263.537h-22.681v-78.845h22.681
			V263.537z M305.655,263.537h-22.681V145.809h22.681V263.537z"
                    />
                </g>
            </g>
        </SvgIcon>
    )
}

export default DetailedAnalysisIcon
